declare const $;
export class gridListController {
  id: any;
  BaseUrlPage: any;
  apiType: any;
  items: any[];
  currentPage: any;
  apiData: any;
  apiMethod: any;
  apiUrl: string;
  AjaxLoading: boolean;
  totalItems;
  constructor(
    private $rootScope,
    private CarouselService,
    private $mPath,
    private $filter,
    private $timeout
  ) {
    "ngInject";
    $mPath.get().then(response => {
      this.BaseUrlPage = response;
      this.LoadData(1);
    });
  }
  LoadData(PageNumber) {
    this.AjaxLoading = true;
    var apiUrl = this.apiUrl + "&PageNumber=" + PageNumber;
    this.CarouselService.get(apiUrl, this.apiMethod, this.apiData).then(
      data => {
        // this.totalItems = data.data.totalItems || 100;
        this.currentPage = PageNumber || 1;
        this.items = [];
        switch (this.apiType) {
          case "Search":
            this.searchForEach(data);
            break;
          case "Product":
            this.productForEach(data);
            break;
          case "Category":
            this.categoryForEach(data);
            break;
        }
        this.$rootScope.$emit("endLoading");
        this.AjaxLoading = false;
      }
    );
  }
  change_page(pageNumber) {
    this.AjaxLoading = true;
    this.items = null;
    this.LoadData(pageNumber);
  }
  searchForEach(data) {
    data.data.Products.map(item => {
      item.url =
        this.BaseUrlPage.StoreProductDetail + "/pID/" + item.ProductID + "/";
    });
    this.items = data.data.Products;
    this.totalItems = data.data.ProductCount;
    // this.$rootScope.$emit('endLoading')
  }

  productForEach(data) {
    data.data.ProductList.map(item => {
      item.url =
        this.BaseUrlPage.StoreProductDetail + "/pID/" + item.ProductID + "/";
    });
    this.items = data.data.ProductList;
    this.totalItems = data.data.TotalCount;
    // this.$rootScope.$emit('endLoading')
  }

  categoryForEach(data) {
    angular.forEach(data.data, function(val, key) {
      var item = {
        ImageFullPath: val.ImageUrl,
        url: this.BaseUrlPage.StoreListByCat + "/#/catID/" + val.CategoryID,
        Name: val.CategoryName
        // Price:  $filter('currency')(val.Meta_MinPrice,'',0) +' تومان '
      };
      this.items.push(item);
    });
    // this.$rootScope.$emit('endLoading', this.items)
  }
}



// WEBPACK FOOTER //
// ./src/components/grid-list/grid-list.controller.ts